import { Outlet } from "react-router-dom";
import styled from "styled-components";
import SidebarComponent from "../../components/Sidebar/new";
import { createContext, useState } from "react";
import { useAppSelector } from "../../store";

import HeaderComponent from "../../components/Header";

interface IHeaderContext {
  headerTitle?: string;
  isRightSideOpen?: boolean;
  backAction?: () => void;
  setBackAction?: React.Dispatch<
    React.SetStateAction<(() => void) | undefined>
  >;
  setHeaderTitle?: React.Dispatch<React.SetStateAction<string | undefined>>;
  setIsRightSideOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const HeaderContext = createContext<IHeaderContext>({
  headerTitle: undefined,
  isRightSideOpen: false,
  backAction: undefined,
  setBackAction: undefined,
  setIsRightSideOpen: undefined,
  setHeaderTitle: undefined,
});

const MainLayout = () => {
  const authState = useAppSelector((state) => state.authReducer);

  const [backAction, setBackAction] = useState<() => void>();
  const [headerTitle, setHeaderTitle] = useState<string>();
  const [isRightSideOpen, setIsRightSideOpen] = useState<boolean>(false);

  return (
    <HeaderContext.Provider
      value={{
        isRightSideOpen,
        headerTitle,
        backAction,
        setBackAction,
        setIsRightSideOpen,
        setHeaderTitle,
      }}
    >
      <Container>
        {/* {authState.me && ( */}
        <SidebarWrapper>
          <SidebarComponent />
        </SidebarWrapper>
        {/* )} */}
        {/* {authState.me && ( */}
        <HeaderWrapper>
          <HeaderComponent />
        </HeaderWrapper>
        {/* )} */}
        <div style={{ paddingTop: 80}}>
          <Outlet
            context={{ setBackAction, setIsRightSideOpen, setHeaderTitle }}
          />
        </div>
      </Container>
    </HeaderContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100svh;
  background-color: #1a1a1a;
  box-sizing: border-box;
`;

const SidebarWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
`;

const HeaderWrapper = styled.div`
  display: none;
  position: relative;

  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 80px;
    z-index: 1000;
    display: flex;
  }
`;

export default MainLayout;
